/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menufiletoolarge3Inputs */

const en_menufiletoolarge3 = /** @type {(inputs: Menufiletoolarge3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is too large: photos up to 10 MB.`)
};

const de_menufiletoolarge3 = /** @type {(inputs: Menufiletoolarge3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist zu groß: Fotos bis 10 MB.`)
};

/**
* | output |
* | --- |
* | "{name} is too large: photos up to 10 MB." |
*
* @param {Menufiletoolarge3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufiletoolarge3 = /** @type {((inputs: Menufiletoolarge3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufiletoolarge3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufiletoolarge3(inputs)
	return de_menufiletoolarge3(inputs)
});
export { menufiletoolarge3 as "menuFileTooLarge" }